import React, { useState, useEffect } from 'react';
import PremiumBadgeNotification from './PremiumBadgeNotification';

const BadgeNotificationSystem = () => {
  const [currentNotification, setCurrentNotification] = useState(null);

  useEffect(() => {
    // Listen for badge earned notifications
    const handleBadgeEarned = (event) => {
      const badgeData = event.detail;
      showNotification(badgeData);
    };

    window.addEventListener('badgeEarned', handleBadgeEarned);
    return () => window.removeEventListener('badgeEarned', handleBadgeEarned);
  }, []);

  const showNotification = (badgeData) => {
    setCurrentNotification(badgeData);
  };

  const handleClose = () => {
    setCurrentNotification(null);
  };

  return (
    <PremiumBadgeNotification
      badgeData={currentNotification}
      onClose={handleClose}
      show={!!currentNotification}
    />
  );
};

export default BadgeNotificationSystem;